import { render, staticRenderFns } from "./Formular.vue?vue&type=template&id=1b121f9f&"
import script from "./Formular.vue?vue&type=script&lang=js&"
export * from "./Formular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports